import PropTypes from 'prop-types';
import React from 'react';
import TableHeader from '../TableHeader';
import PageNumber from './PageNumber';
import IrdReportHeader from './IrdReportHeader';
import IrdReportPrintBody from './IrdReportPrintBody';

const LedgerReportPrintBody = ({
  dataList,
  tableConfig,
  columnTotal,
  domainConfig,
  date,
  nepaliDate,
  company,
  disableUpperHeaderDetails,
  colSpanTotal,
  nepaliDateExist,
  singleDate,
  singleDateExist,
}) => {
  return (
    <div>
      {dataList.map((chunk, key) => {
        const { list = [], footer = false, page = 0,remainingLines=[] } = chunk;
        return (
          <div className='print-body zoom-reduce'>
            <div className='pdf-body card-body'>
              <IrdReportHeader
                divClassName='first-header-bar'
                domainConfig={domainConfig}
                nepaliDate={nepaliDate}
                company={company}
                date={date}
                nepaliDateExist={nepaliDateExist}
                singleDate={singleDate}
                singleDateExist={singleDateExist}
              />
              <div className={` fixed-table-wrapper ${!footer ? 'report-table-wrapper ' : 'report-table-footer'}`}>
                <table className='pdf-table'>
                  <TableHeader headerDetails={tableConfig.header} filterHeaderLabel={false} />
                  {tableConfig.getTableBody({ dataList: list ,remainingLines:remainingLines})}
                  {/* { footer && (tableConfig.getTableFooter({ columnTotal ,colSpanTotal}))} */}
                </table>
              </div>
            </div>
            <div className='footer-block'>
              <PageNumber value={page} totalPage={dataList.length} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LedgerReportPrintBody;

LedgerReportPrintBody.propTypes = {
  columnTotal: PropTypes.instanceOf(Object),
  dataList: PropTypes.instanceOf(Array),
  tableConfig: PropTypes.shape({
    getTableBody: PropTypes.func.isRequired,
    getTableFooter: PropTypes.func,
    header: PropTypes.instanceOf(Object),
  }).isRequired,
  domainConfig: PropTypes.instanceOf(Object),
};

LedgerReportPrintBody.defaultProps = {
  columnTotal: {},
  dataList: [],
  domainConfig: {},
};
